import { render, staticRenderFns } from "./activity-categories.vue?vue&type=template&id=ca781cf0&scoped=true&"
import script from "./activity-categories.ts?vue&type=script&lang=ts&"
export * from "./activity-categories.ts?vue&type=script&lang=ts&"
import style0 from "./activity-categories.scss?vue&type=style&index=0&id=ca781cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca781cf0",
  null
  
)

export default component.exports